import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { InboundEmail } from '../api/models';
import { Skeleton, notification } from 'antd';
import moment from 'moment';
import APIClient from '../api/api';
import EmailTagList from '../components/EmailTagList';
import { Button } from '../components/ui';
import { PageBody, PageHead } from '../layout';

const EmailView = () => {
  const { id } = useParams();
  const [email, setEmail] = useState<InboundEmail>();
  const navigate = useNavigate();

  useEffect(() => {
    loadEmail();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  async function loadEmail() {
    if (!id) return;
    try {
      setEmail(undefined);
      const resp = await APIClient.getEmail(parseInt(id));
      setEmail(resp);
    } catch (e) {
      notification.error({ message: 'Failed to load email.' });
    }
  }

  return (
    <>
      <PageHead
        title={email?.subject || 'Email'}
        subtitle={email ? `From ${email.from} · ${moment(email.sentAt).format('LLL')}` : 'Loading…'}
        actions={
          <Button variant="ghost" onClick={() => navigate(-1)}>
            ← Back
          </Button>
        }
      />
      <PageBody>
        <Skeleton loading={!email}>
          {email && (
            <div className="max-w-[900px] mx-auto">
              {email.tags && email.tags.length > 0 && (
                <div className="mb-4">
                  <EmailTagList
                    onTagsUpdated={() => {
                      window.location.reload();
                    }}
                    removable
                    email={email}
                  />
                </div>
              )}
              <div className="bg-bg-elevated border border-border rounded-md p-5">
                <dl className="grid grid-cols-[80px_1fr] gap-x-3 gap-y-1.5 text-[12.5px] mb-4 pb-4 border-b border-border">
                  <dt className="text-text-3 font-semibold uppercase text-[10.5px] tracking-wider self-center">
                    Date
                  </dt>
                  <dd className="text-text-2 font-mono tabular-nums">
                    {moment(email.sentAt).format('LLL')}
                  </dd>
                  <dt className="text-text-3 font-semibold uppercase text-[10.5px] tracking-wider self-center">
                    Subject
                  </dt>
                  <dd className="text-text">{email.subject}</dd>
                  <dt className="text-text-3 font-semibold uppercase text-[10.5px] tracking-wider self-center">
                    From
                  </dt>
                  <dd className="text-text-2 font-mono break-all">{email.from}</dd>
                  <dt className="text-text-3 font-semibold uppercase text-[10.5px] tracking-wider self-center">
                    To
                  </dt>
                  <dd className="text-text-2 font-mono break-all">
                    {email.to.length === 0 ? 'UNKNOWN' : email.to}
                  </dd>
                </dl>
                <pre className="whitespace-pre-wrap text-text text-[12.5px] font-sans">
                  {email.text}
                </pre>
              </div>
            </div>
          )}
        </Skeleton>
      </PageBody>
    </>
  );
};

export default EmailView;
